import React, { useEffect, useState, useRef, useMemo, useCallback} from 'react';
import { useParams, Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import AddPortfolioModal from '../components/profile/AddPortfolioModal';
import EditModelProfileModal from '../components/profile/EditModelProfileModal';
import CompCardModal from '../components/profile/CompCardModal';

// import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { collaborationAPI, genericAPIs, messagesAPI, userAPI, searchAPI } from '../services/api';
import { IS_INSTAGRAM_SYNC_ENABLED } from '../utils/featureFlags';
// import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import UserRelationshipModal from '../components/profile/UserRelationshipModal';
import { userRelationshipAPI } from '../services/api';
// import { useAppSelector, useAppDispatch } from '../hooks/redux';
import { useUserCounts } from '../hooks/useUserCounts';
import { useRestrictions } from '../hooks/useRestrictions';
// [Subscription removed] UpgradePopup removed — platform is fully free.
// import UpgradePopup from '../components/common/UpgradePopup';

import { 
  MapPinIcon, 
  StarIcon, 
  CheckBadgeIcon,
  CameraIcon,
  UserIcon,
  PencilIcon,
  ChatBubbleLeftIcon,
  EyeIcon,
  HeartIcon,
  ShareIcon,
  UsersIcon,
  GlobeAltIcon,
  DevicePhoneMobileIcon,
  HomeIcon,
  ArrowTopRightOnSquareIcon,
  ArrowLeftIcon,
  PlusIcon,
  XMarkIcon, 
  PaperAirplaneIcon,
  MinusIcon,
  ArrowPathIcon,
  UserGroupIcon,
  ClockIcon,
  EnvelopeIcon,
  TrashIcon,
  UserPlusIcon,
  UserMinusIcon,
  LockClosedIcon,
  PhotoIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  SparklesIcon,
  IdentificationIcon,
  FolderIcon
} from '@heroicons/react/24/outline';
import Avatar from '../components/common/Avatar';
import { FaInstagram } from 'react-icons/fa';
import { useAppSelector, useAppDispatch } from '../hooks/redux';
import { fetchUserProfile, updateProfileUserInState, clearProfileUser } from '../store/slices/userSlice';
import Button from '../components/common/Button';
import ReviewsSection from '../components/profile/ReviewsSection';
import { getOptimizedImageUrl, resolveImageUrl } from '../utils/image';
import ShareModal from '../components/common/ShareModal';
import SmartImage from '../components/common/SmartImage';
import Logo from '../components/common/Logo';
import Masonry from 'react-masonry-css';

import PhotoCropperModal from '../components/profile/PhotoCropperModal';
import MasonryPortfolioGrid from '../components/profile/MasonryPortfolioGrid';
import PortfolioFolderGrid from '../components/profile/PortfolioFolderGrid';
import CreateFolderModal from '../components/profile/CreateFolderModal';
import CollaborationGrid from '../components/collaboration/CollaborationGrid';
import ServicePackagesList from '../components/profile/ServicePackagesList';
import ShowcaseTab from '../components/profile/showcase/ShowcaseTab';
import VideoSection from '../components/profile/VideoSection';
import ClientPortal from '../components/profile/ClientPortal';
import ProfileChecklist from '../components/profile/ProfileChecklist';
import RewardUnlockedModal, { RewardData } from '../components/dashboard/RewardUnlockedModal';


import {Collaboration, Portfolio, PortfolioFolder} from '../types'
import CreateCollaborationModal from '../components/collaboration/CreateCollaborationModal';
import { InstagramImportModal } from '../components/instagram/InstagramImportModal';

import { fetchUserCollaborations } from '../store/slices/collaborationSlice';
import { updateUser, updateUserCounts } from '../store/slices/authSlice';
import CollaborationRequestModal from '../components/collaboration/CollaborationRequestModal';
import MultiSelectDropdown from '../components/common/MultiSelectDropdown';
import LocationText from '../components/common/LocationText';
import ConfirmationModal from '../components/common/ConfirmationModal';
import { formatCurrency, getUserRoleLabel } from '../utils/format';
import SEOHead from '../components/common/SEOHead';
import LoginPromptModal from '../components/common/LoginPromptModal';
import CollaborationOptionsModal from '../components/explore/CollaborationOptionsModal';
import GuestHeader from '../components/layout/GuestHeader';


interface Message {
    id: string;
    content: string;
    sender_id: string;
    created_at: string;
    sender?: {
      id: string;
      first_name: string;
      last_name: string;
      profile_pic?: string;
    };
  }
  
  interface Conversation {
    id: string;
    participants: any[];
    last_message?: Message;
    unread_count: number;
  }


// const [showProfilePhotoModal, setShowProfilePhotoModal] = useState(false);
// const [showCoverPhotoModal, setShowCoverPhotoModal] = useState(false);

  // Fix 1: Default images
const getDefaultCoverPhoto = () => {    
    return 'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=400&q=80';
};

const getDefaultProfilePhoto = () => {
    return 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=400&q=80';
};

const getImageUrl = (imagePath?: string, type: 'profile' | 'cover' = 'profile') => {
    if (!imagePath) {
      return type === 'profile' ? getDefaultProfilePhoto() : getDefaultCoverPhoto();
    }
    
    return resolveImageUrl(imagePath);
  };

const InstagramIcon = FaInstagram as any;

const ProfilePage: React.FC = () => {
  type tab_type = 'portfolio' | 'showcase' | 'reviews' | 'projects' | 'services' | 'my-projects' | 'digitals'
  const { id, active_tab, item_id, folder_id } = useParams<{id: string; active_tab?: tab_type; item_id?: string; folder_id?: string}>();
  // // console.log("ProfilePage Params:", { id, active_tab, item_id });
  // // console.log("ProfilePage Rendered");
  const dispatch = useAppDispatch();
  const { user: currentUser, role, isAuthenticated } = useAppSelector((state) => state.auth);
  const { profileUser, loading, error } = useAppSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState<tab_type>(active_tab ? active_tab : 'portfolio');
  const [showEditModelSpecsModal, setShowEditModelSpecsModal] = useState(false);
  const [showCompCardModal, setShowCompCardModal] = useState(false);
  
  // Local portfolio state with pagination
  const [portfolio, setPortfolio] = useState<Portfolio[]>([]);
  const [portfolioLoading, setPortfolioLoading] = useState(false);
  const [refreshFolderTrigger, setRefreshFolderTrigger] = useState(0);
  const [portfolioPage, setPortfolioPage] = useState(1);
  const [hasMorePortfolio, setHasMorePortfolio] = useState(true);

  // Reset page index synchronously when switching folders
  const prevFolderId = useRef(folder_id);
  if (prevFolderId.current !== folder_id) {
    prevFolderId.current = folder_id;
    setPortfolioPage(1);
  }
  
  // Portfolio Folders State
  const [portfolioFolders, setPortfolioFolders] = useState<PortfolioFolder[]>([]);
  const [foldersLoading, setFoldersLoading] = useState(false);
  const [portfolioViewMode, setPortfolioViewMode] = useState<'folders' | 'grid'>('grid');
  const [selectedFolder, setSelectedFolder] = useState<PortfolioFolder | null>(null);
  const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
  const [editingFolder, setEditingFolder] = useState<PortfolioFolder | null>(null);

  // Set initial view mode based on user preference
  const hasSetInitialView = useRef(false);
  const lastLoadedProfileId = useRef<string | null>(null);

  useEffect(() => {
    // If the profile ID has actually changed, reset the initial view flag
    if (profileUser?.id && profileUser.id !== lastLoadedProfileId.current) {
        hasSetInitialView.current = false;
        lastLoadedProfileId.current = profileUser.id;
    }
  }, [profileUser?.id]);

  useEffect(() => {
    // Set from profile preference if we haven't set an initial view yet
    if (!hasSetInitialView.current && !folder_id && profileUser) {
      if (profileUser.default_portfolio_view) {
        setPortfolioViewMode(profileUser.default_portfolio_view as 'folders' | 'grid');
      }
      if (profileUser.default_portfolio_tab) {
        setPortfolioSubTab(profileUser.default_portfolio_tab as 'photos' | 'videos');
      } else if (profileUser.creator_sub_type === 'videographer') {
        setPortfolioSubTab('videos');
      }
      if (profileUser.default_portfolio_view || profileUser.default_portfolio_tab || profileUser.creator_sub_type === 'videographer') {
        hasSetInitialView.current = true;
      }
    }
  }, [profileUser?.id, profileUser?.default_portfolio_view, profileUser?.default_portfolio_tab, profileUser?.creator_sub_type, folder_id]);

  // Tag filtering state
  const [availableTags, setAvailableTags] = useState<string[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const effectiveId = id || currentUser?.id;
  // Synchronous state reset when effective profile ID changes during render
  const prevEffectiveId = useRef(effectiveId);
  if (prevEffectiveId.current !== effectiveId) {
    prevEffectiveId.current = effectiveId;
    setPortfolio([]);
    setPortfolioFolders([]);
    setSelectedFolder(null);
    setPortfolioPage(1);
    setHasMorePortfolio(true);
    setSelectedTags([]);
    setAvailableTags([]);
  }

  // Fetch available tags
  useEffect(() => {
    const fetchTags = async () => {
      const targetUserId = id || currentUser?.id;
      if (!targetUserId) return;

      try {
        const response = await userAPI.getUserPortfolioTags(targetUserId);
        if (response.data.success) {
            setAvailableTags(response.data.data || []);
        }
      } catch (error) {
        console.error('Failed to fetch tags:', error);
      }
    };
    fetchTags();
  }, [id, currentUser?.id]);

  const toggleTag = (tag: string) => {
    setSelectedTags(prev => {
        const newTags = prev.includes(tag) 
            ? prev.filter(t => t !== tag)
            : [...prev, tag];
        setPortfolioPage(1); // Reset to first page when filter changes
        return newTags;
    });
  };


  
  // Store the initial tab (the one loaded at first render)
  const initialTab = useRef<tab_type>(active_tab ? active_tab : 'portfolio');
  // Ref for scrolling to tabs section
  const tabsRef = useRef<HTMLDivElement>(null);
  
  

  const [showProfilePhotoModal, setShowProfilePhotoModal] = useState(false);
  const [showCoverPhotoModal, setShowCoverPhotoModal] = useState(false);
  const [showFullProfilePic, setShowFullProfilePic] = useState(false);
  const [selectedDigitalIndex, setSelectedDigitalIndex] = useState<number | null>(null);

  const [collaborations, setCollaborations] = useState<Collaboration[]>([]);
    const [collaborationsLoading, setCollaborationsLoading] = useState(false);
    const [showCreateCollaboration, setShowCreateCollaboration] = useState(false);
    const [rewardModalData, setRewardModalData] = useState<RewardData | null>(null);
    const { userCollaborations } = useAppSelector(state => state.collaboration);

    const handleSetDefaultView = async () => {
      try {
        await userAPI.updateProfile({ default_portfolio_view: portfolioViewMode });
        toast.success(`Default view set to ${portfolioViewMode}`);
        // Immediately update local auth state so the button hides
        dispatch(updateUser({ default_portfolio_view: portfolioViewMode }));
        // Also refresh profile
        if (currentUser) {
          dispatch(fetchUserProfile(currentUser.id));
        }
      } catch (error) {
        console.error('Failed to update default view:', error);
        toast.error('Failed to update default view');
      }
    };

    const handleSetDefaultTab = async () => {
      try {
        await userAPI.updateProfile({ default_portfolio_tab: portfolioSubTab });
        toast.success(`Default tab set to ${portfolioSubTab}`);
        dispatch(updateUser({ default_portfolio_tab: portfolioSubTab }));
        if (currentUser) {
          dispatch(fetchUserProfile(currentUser.id));
        }
      } catch (error) {
        console.error('Failed to update default tab:', error);
        toast.error('Failed to update default tab');
      }
    };

    const navigate = useNavigate();
    const location = useLocation();
    const [isMessaging, setIsMessaging] = useState(false);
    const [userRole, setUserRole] = useState(false);
    const [isFollowing, setIsFollowing] = useState(false);
    const [isSharing, setIsSharing] = useState(false);

    const [isChatOpen, setIsChatOpen] = useState(false);
    const [isChatMinimized, setIsChatMinimized] = useState(false);
    const [isLoadingChat, setIsLoadingChat] = useState(false);
    const [conversation, setConversation] = useState<Conversation | null>(null);
    const [messages, setMessages] = useState<Message[]>([]);
    const [newMessage, setNewMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const chatInputRef = useRef<HTMLInputElement>(null);
    const [existingRequest, setExistingRequest] = useState<any>(null);
    const [showCollaborationModal, setShowCollaborationModal] = useState(false);
    const [showCollaborationOptions, setShowCollaborationOptions] = useState(false);

    const [showRelationshipModal, setShowRelationshipModal] = useState(false);
    const [relationshipModalTab, setRelationshipModalTab] = useState<'followers' | 'following' | 'collaborators'>('followers');
    const [isFollowingUser, setIsFollowingUser] = useState(false);
    const [checkingFollowStatus, setCheckingFollowStatus] = useState(false);
    const [followLoading, setFollowLoading] = useState(false);
    const [collaborationInitialValues, setCollaborationInitialValues] = useState<any>(null);

    const handleBookService = (pkg: any) => {
      // Show login modal for guests
      if (!currentUser) {
        setLoginModalMessage('Sign in to book this service and connect with the creator');
        setShowLoginModal(true);
        return;
      }

      setCollaborationInitialValues({
        service_package_id: pkg.id,
        service_package: pkg,
        budget: pkg.price,
        description: `Booking service package: ${pkg.title}\n\nDescription: ${pkg.description}`,
      });
      setShowCollaborationModal(true);
    };

  const isOwnProfile = !id || String(id) === String(currentUser?.id);
  const user = useMemo(() => {
    return isOwnProfile ? currentUser : profileUser;
  }, [isOwnProfile, currentUser, profileUser]);

  const [showAddPortfolioModal, setShowAddPortfolioModal] = useState(false);
  const [isIgImportModalOpen, setIsIgImportModalOpen] = useState(false);
  const [igImportMode, setIgImportMode] = useState<'photos' | 'project'>('photos');
  const [instagramPreFill, setInstagramPreFill] = useState<any>(null);
  const [searchParams] = useSearchParams();
  const [portfolioSubTab, setPortfolioSubTab] = useState<'photos' | 'videos'>('photos');
  const [igProfileData, setIgProfileData] = useState<any>(null);

  const handleInstagramSyncClick = (mode?: 'photos' | 'project' | React.MouseEvent) => {
    const targetMode = (typeof mode === 'string' && (mode === 'photos' || mode === 'project')) ? mode : 'photos';
    setIgImportMode(targetMode);
    setIsIgImportModalOpen(true);
  };

  const handleInstagramPhotosSuccess = (imported: number, skipped: number) => {
    toast.success(`Instagram sync completed! Imported ${imported} new items, skipped ${skipped} duplicates.`);
    setPortfolio([]);
    setPortfolioPage(1);
    setRefreshFolderTrigger(prev => prev + 1);
  };

  useEffect(() => {
      const action = searchParams.get('action');
      if (action === 'add-portfolio' && isOwnProfile) {
          // [Subscription removed] Portfolio item creation is unrestricted.
          setActiveTab('portfolio');
          setShowAddPortfolioModal(true);
      } else if (action === 'create-collaboration' && isOwnProfile) {
          // [Subscription removed] Collaboration post creation is unrestricted.
          setActiveTab('projects');
          setShowCreateCollaboration(true);
      } else if (action === 'upload-photo' && isOwnProfile) {
          setShowProfilePhotoModal(true);
      }
  }, [searchParams, isOwnProfile]);


  
  const formatUrl = (url: string): string => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    return `https://${url}`;
  };

    // Helper function to format Instagram URL
    const getInstagramUrl = (handle: string): string => {
        if (!handle) return '';
        const cleanHandle = handle.replace('@', '');
        return `https://instagram.com/${cleanHandle}`;
      };
    
      // Helper function to format Google Maps URL
      // const getMapUrl = (location: string): string => {
      //   if (!location) return '';
      //   return `https://maps.google.com/?q=${encodeURIComponent(location)}`;
      // };
    
      // Helper function to format phone URL
      const getPhoneUrl = (phone: string): string => {
        if (!phone) return '';
        return `tel:${phone}`;
      };

      const getMailUrl = (email: string): string => {
        if (!email) return '';
        return `mailto:${email}`;
      };

  const containerRef = useRef<HTMLDivElement>(null);

  const prevEffectiveIdRef = useRef(effectiveId);

  // Fix 3: Ensure API call is made for other users
  useEffect(() => {
    // console.log('🚀 Profile fetch useEffect triggered:', { 
    //   id, 
    //   currentUserId: currentUser?.id,
    //   effectiveId 
    // });
    
    // Scroll to top of container ONLY if the effective profile ID changes
    // This prevents scrolling when switching from /profile (implicit ID) to /profile/:id (explicit ID)
    if (effectiveId !== prevEffectiveIdRef.current) {
        if (containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
        prevEffectiveIdRef.current = effectiveId;
        hasSetInitialView.current = false;
        dispatch(clearProfileUser());
        setPortfolio([]);
        setPortfolioFolders([]);
        setSelectedFolder(null);
        setPortfolioPage(1);
        setHasMorePortfolio(true);
        setSelectedTags([]);
        setAvailableTags([]);
    }

    // Force API call for debugging
    const targetUserId = id || currentUser?.id;
    if (targetUserId) {      
      // Add a Promise to track the result
      dispatch(fetchUserProfile(targetUserId)).then((result: any) => {
        if (fetchUserProfile.rejected.match(result)) {
          // console.log('Profile fetch failed:', result.payload);
        }
      });
    }
  }, [dispatch, id, currentUser?.id, effectiveId]);

  // Separate effect for tab synchronization to avoid scrolling on tab change
  useEffect(() => {
    if (active_tab && ['portfolio', 'showcase', 'reviews', 'projects', 'services', 'my-projects', 'digitals'].includes(active_tab)) {
      setActiveTab(active_tab as tab_type);
      // Scroll to tabs section when navigating via URL
      setTimeout(() => {
        tabsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300); // Small delay to ensure DOM is ready
    } else if (!active_tab && !item_id) {
        if (user?.user_type === 'hirer') {
            setActiveTab('projects');
        } else {
            setActiveTab('portfolio');
        }
    }
  }, [active_tab, item_id, user?.user_type]);

  // Fetch portfolios with backend pagination
  useEffect(() => {
    const targetUserId = id || currentUser?.id;
    if (!targetUserId || folder_id) return;

    let isCancelled = false;

    const fetchPortfolios = async () => {
      try {
        setPortfolioLoading(true);
        const response = await userAPI.getUserPortfolio(targetUserId, portfolioPage, 12, selectedTags);
        
        if (!isCancelled && response.data.success) {
          const newPortfolios = response.data.data.portfolio || [];
          
          // Append new portfolios to existing ones for infinite scroll
          setPortfolio(prev => portfolioPage === 1 ? newPortfolios : [...prev, ...newPortfolios]);
          setHasMorePortfolio(response.data.data.has_more || false);
        }
      } catch (error) {
        if (!isCancelled) {
          console.error('Failed to fetch portfolios:', error);
          setHasMorePortfolio(false); // Stop infinite scroll on error
          if (portfolioPage === 1) {
            setPortfolio([]);
          }
        }
      } finally {
        if (!isCancelled) {
          setPortfolioLoading(false);
        }
      }
    };

    fetchPortfolios();

    return () => {
      isCancelled = true;
    };
  }, [id, currentUser?.id, portfolioPage, selectedTags, folder_id, refreshFolderTrigger]);

  // Fetch portfolio folders
  useEffect(() => {
    const targetUserId = id || currentUser?.id;
    if (!targetUserId) return;

    let isCancelled = false;

    const fetchFolders = async () => {
      try {
        setFoldersLoading(true);
        const response = await userAPI.getPortfolioFolders(targetUserId);
        if (!isCancelled && response.data.success) {
          const folders: PortfolioFolder[] = response.data.data || [];
          setPortfolioFolders(folders);
          
          // Fallback to grid view if no folders are present or all folders are empty
          const hasFoldersWithImages = folders.length > 0 && folders.some(f => (f.item_count || 0) > 0);
          if (!hasFoldersWithImages) {
            setPortfolioViewMode('grid');
            hasSetInitialView.current = true;
          }
        }
      } catch (error) {
        if (!isCancelled) {
          console.error('Failed to fetch portfolio folders:', error);
        }
      } finally {
        if (!isCancelled) {
          setFoldersLoading(false);
        }
      }
    };

    fetchFolders();

    return () => {
      isCancelled = true;
    };
  }, [id, currentUser?.id, refreshFolderTrigger]);

  // Fetch folder items if viewing a specific folder
  useEffect(() => {
    const targetUserId = id || currentUser?.id;
    if (folder_id && activeTab === 'portfolio' && targetUserId) {
      let isCancelled = false;

      const fetchFolderItems = async () => {
        try {
          setPortfolioLoading(true);
          const response = await userAPI.getFolderItems(targetUserId, folder_id, portfolioPage, 12);
          if (!isCancelled && response.data.success) {
            const newItems = response.data.data.portfolio || [];
            setPortfolio(prev => portfolioPage === 1 ? newItems : [...prev, ...newItems]);
            setHasMorePortfolio(response.data.data.has_more || false);
            
            // Set view mode to grid to show the masonry
            setPortfolioViewMode('grid');
            
            // If we don't have the selected folder object yet, find it
            if (!selectedFolder && portfolioFolders.length > 0) {
              const folder = portfolioFolders.find(f => f.id === folder_id);
              if (folder) setSelectedFolder(folder);
            }
          }
        } catch (error) {
          if (!isCancelled) {
            console.error('Failed to fetch folder items:', error);
            toast.error('Failed to load folder items');
            setHasMorePortfolio(false);
            if (portfolioPage === 1) {
              setPortfolio([]);
            }
          }
        } finally {
          if (!isCancelled) {
            setPortfolioLoading(false);
          }
        }
      };
      fetchFolderItems();

      return () => {
        isCancelled = true;
      };
    } else if (!folder_id && activeTab === 'portfolio') {
        // Reset view mode to 'folders' when leaving a folder, if folders with images exist and folders is the preferred view
        const hasFoldersWithImages = portfolioFolders.length > 0 && portfolioFolders.some(f => (f.item_count || 0) > 0);
        const preferredView = profileUser?.default_portfolio_view || 'grid';
        
        if (hasFoldersWithImages && preferredView === 'folders' && portfolioViewMode === 'grid') {
            setPortfolioViewMode('folders');
        }
    }
  }, [folder_id, activeTab, portfolioPage, portfolioFolders, id, currentUser?.id, refreshFolderTrigger]);

  const handleLoadMorePortfolio = useCallback(() => {
    if (!portfolioLoading && hasMorePortfolio) {
      setPortfolioPage(prev => prev + 1);
    }
  }, [portfolioLoading, hasMorePortfolio]);

  useEffect(() => {
      if (location.hash) {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);

    // Removed redundant useEffect for active_tab

    // Effect to clear itemId when tab changes
    useEffect(() => {
      if (activeTab !== initialTab.current) {
        // Only clear if we are NOT navigating to a specific item
        if (!item_id) {
            // Do nothing or handle as needed
        }
      }
    }, [activeTab, item_id]);

  useEffect(() => {
    if (profileUser && currentUser?.id === profileUser.id) {
        // Only update if there's a probable change to avoid infinite loops
        // The comparison logic could be more thorough, but this is a safe guard
        if (profileUser.updated_at !== currentUser.updated_at || !currentUser.first_name) {
            dispatch(updateUser(profileUser));
        }
    }
  }, [profileUser, currentUser?.id, currentUser?.updated_at, dispatch]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (isChatOpen && !isChatMinimized) {
      scrollToBottom();
    }
  }, [messages, isChatOpen, isChatMinimized]);

  // Focus input when chat opens
  useEffect(() => {
    if (isChatOpen && !isChatMinimized && chatInputRef.current) {
      chatInputRef.current.focus();
    }
  }, [isChatOpen, isChatMinimized]);

  useEffect(() => {
    if (!isOwnProfile && user && currentUser) {
      setCheckingFollowStatus(true);
      userRelationshipAPI.checkFollowStatus(user.id)
        .then(response => {
          setIsFollowingUser(response.data.data.following);
        })
        .catch(error => {
          console.error('Failed to check follow status:', error);
        })
        .finally(() => {
          setCheckingFollowStatus(false);
        });
    }
  }, [isOwnProfile, user?.id, currentUser?.id, user]);
  
  // Safety check: ensure grid view is selected if folders are empty or have no images (only for visitors)
  useEffect(() => {
    if (!isOwnProfile && activeTab === 'portfolio' && !foldersLoading && !folder_id) {
       const hasFoldersWithImages = portfolioFolders.length > 0 && portfolioFolders.some(f => (f.item_count || 0) > 0);
       if (!hasFoldersWithImages && portfolioViewMode === 'folders') {
         setPortfolioViewMode('grid');
       }
    }
  }, [activeTab, foldersLoading, portfolioFolders, portfolioViewMode, folder_id, isOwnProfile]);

  const checkExistingCollaborationRequest = async () => {
    if (!currentUser || currentUser.id === id) return;

    try {
      const response = await collaborationAPI.getCollaborationRequests({
        collab_type: 'all',
        status: 'pending'
      });

      // console.log("getCollaborationRequests", response)
      
      const existingReq = response.data.data.data.find((req: any) => 
        req.receiver_id === id
      );
      setExistingRequest(existingReq);
    } catch (error) {
      console.error('Failed to check existing requests:', error);
    }
  };

  const [deleteConfirmation, setDeleteConfirmation] = useState<{
    isOpen: boolean;
    type: 'profile' | 'cover' | null;
  }>({
    isOpen: false,
    type: null
  });
  
  const [showShareModal, setShowShareModal] = useState(false);

  const handleDeletePhoto = (type: 'profile' | 'cover') => {
    setDeleteConfirmation({
      isOpen: true,
      type
    });
  };

  const handleConfirmDelete = async () => {
    if (!user || !deleteConfirmation.type) return;

    try {
      const isProfile = deleteConfirmation.type === 'profile';
      const cleanPhotoFields = {
        [isProfile ? 'profile_pic' : 'cover_photo']: '',
        [isProfile ? 'profile_pic_signed' : 'cover_photo_signed']: '',
        [isProfile ? 'profile_pic_thumb_signed' : 'cover_photo_thumb_signed']: '',
        [isProfile ? 'profile_pic_medium_signed' : 'cover_photo_medium_signed']: ''
      };
      const updateData = {
        ...user,
        ...cleanPhotoFields
      };
      
      await userAPI.updateProfile(updateData);
      
      // Update local state
      dispatch(updateUser(cleanPhotoFields));
      toast.success('Photo deleted successfully');
    } catch (error) {
      console.error('Failed to delete photo:', error);
      toast.error('Failed to delete photo');
    } finally {
      setDeleteConfirmation({ isOpen: false, type: null });
    }
  };

  // Add these handler functions
  const handleShowRelationships = (tab: 'followers' | 'following' | 'collaborators') => {
    setRelationshipModalTab(tab);
    setShowRelationshipModal(true);
  };
  
  const handleFollowToggle = async () => {
    if (!user || followLoading) return;
    
    setFollowLoading(true);
    try {
      const response = await userRelationshipAPI.toggleFollow(user.id);
      const following = response.data.data.following;

      setIsFollowingUser(following);

      if (response.data.success) {
        dispatch(updateUser({
            following_count: (currentUser?.following_count || 0) + (following ? 1 : -1),
          }));
        // // console.log(
        //     "ppo"
        // )
          dispatch(updateProfileUserInState({
            followers_count: (profileUser?.followers_count || 0) + (following ? 1 : -1),
          }));

          
      }

      // console.log("currentUser:", response); // should log updated value
      toast.success(following ? 'Following user!' : 'Unfollowed user');
    } catch (error: any) {
      console.error('Failed to toggle follow:', error);
      toast.error('Failed to update follow status');
    } finally {
      setFollowLoading(false);
    }
  };

  const renderCollaborationButton = () => {
    if (!currentUser || currentUser.id === id || !profileUser) {
      return null;
    }

    // Hide if target user is hirer (they can't be in collaborations)
    if (profileUser.user_type === 'hirer') {
      return null;
    }

    // Show different states based on existing request
    if (existingRequest) {
      return (
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-2 px-4 py-2 bg-orange-50 border border-orange-200 rounded-lg">
            <ClockIcon className="h-4 w-4 text-orange-600" />
            <span className="text-sm text-orange-700 font-medium">
              Request Pending
            </span>
          </div>
          {/* <Button
            variant="outline"
            onClick={() => toast.success('You can cancel this request from your dashboard')}
            className="text-sm"
          >
            Manage Request
          </Button> */}
        </div>
      );
    }

    return (
      <Button
        variant="primary"
        size="icon"
        onClick={() => {
          // [Subscription removed] Collaboration request creation is unrestricted.
          setCollaborationInitialValues(null);
          setShowCollaborationModal(true);
        }}
        className="rounded-full shadow-lg shadow-primary-500/30 flex items-center justify-center transform hover:-translate-y-0.5 transition-all duration-200"
        title="Collaborate"
      >
        <UserGroupIcon className="h-5 w-5" />
      </Button>
    );
  };

  const handleCollaborationSuccess = () => {
    setShowCollaborationModal(false);
    checkExistingCollaborationRequest();
  };

//   useEffect(() => {
//     // console.log("hello")
//     const fetchCollaborations = async () => {
//       if (!user) return;
      
//       setCollaborationsLoading(true);
//       try {
//         const targetUserId = id || user.id;
//         // console.log('📡 Fetching collaborations for user:', targetUserId);
        
//         // Replace with your actual API call
//         const response = await fetch(`/api/v1/collaborations/user/${targetUserId}`, {
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//             'Content-Type': 'application/json'
//           }
//         });
//         // console.log('📡 Fetching sssss for user:', response);

//         if (response.ok) {
//           const data = await response.json();
//           setCollaborations(data.data || []);
//           // console.log('✅ Collaborations loaded:', data.data?.length || 0);
//         } else {
//           console.error('❌ Failed to fetch collaborations:', response.status);
//           setCollaborations([]);
//         }
//       } catch (error) {
//         console.error('❌ Error fetching collaborations:', error);
//         setCollaborations([]);
//       } finally {
//         setCollaborationsLoading(false);
//       }
//     };
  
//     if (activeTab === 'collaborations') {
//       fetchCollaborations();
//     }
//   }, [activeTab, id, user]);




  useEffect(() => {
    // Fetch data for Summary View or specific tabs
    // For guests, we only have `id` from URL. For logged-in users viewing their own profile, use currentUser?.id
    const targetUserId = id || currentUser?.id;
    if (!targetUserId) return;

    dispatch(fetchUserCollaborations(targetUserId));
  }, [id, currentUser?.id, dispatch]);

  // Login Prompt Modal State (for guests)
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAllCities, setShowAllCities] = useState(false); // Toggle for location tags
  const [loginModalMessage, setLoginModalMessage] = useState('Sign in to connect with this creator and start collaborating');

  const handleMessage = async () => {
    if (!currentUser) {
      setLoginModalMessage('Sign in to message this creator');
      setShowLoginModal(true);
      return;
    }
    if (!user || isOwnProfile) return;
    // console.log("hanlder", user)
    
    // Navigate to messages page with complete user info
    navigate('/messages', { 
      state: { 
        openConversationWith: user.id,
        userName: `${user.first_name} ${user.last_name}`,
        userAvatar: user.profile_pic,
        userType: user.user_type,
      } 
    });
  };

  const handleFollow = async () => {
    if (!currentUser) {
      setLoginModalMessage('Sign in to follow this creator');
      setShowLoginModal(true);
      return;
    }
    if (!user || isOwnProfile) return;
    
    setIsFollowing(true);
    try {
      // Implement follow/unfollow logic here
      // For now, we'll show a success message
      toast.success(`You are now following ${user.first_name} ${user.last_name}`);
      
      // You can add your follow API call here:
      // await api.post(`/users/${user.id}/follow`);
      
    } catch (error) {
      console.error('Failed to follow user:', error);
      toast.error('Failed to follow user. Please try again.');
    } finally {
      setIsFollowing(false);
    }
  };

  const handleShare = async () => {
    setShowShareModal(true);
  };
  
  

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <StarIcon
        key={i}
        className={`h-5 w-5 ${
          i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'
        }`}
      />
    ));
  };

  // Show loading if we should have a user but don't yet
  // 1. If viewing own profile but currentUser not loaded yet (and authenticated)
  // 2. If viewing other profile but profileUser not loaded yet
  // 3. BUT NOT if there is an error
  const shouldBeLoading = !error && ((isOwnProfile && isAuthenticated && !currentUser) || (!isOwnProfile && !profileUser));

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-[60vh]">
        <SEOHead 
          title="User Not Found" 
          description="The user you are looking for does not exist or has been deleted." 
          noindex={true} 
        />
        <div className="bg-red-50 dark:bg-red-900/20 p-6 rounded-full mb-4">
            <UserIcon className="h-12 w-12 text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">User Not Found</h1>
        <p className="text-gray-500 dark:text-gray-400 mb-6 text-center max-w-md">
            {error || "The user you are looking for does not exist or has been deleted."}
        </p>
        <Link 
            to="/explore" 
            className="px-6 py-2.5 bg-black dark:bg-white text-white dark:text-black rounded-xl font-medium hover:opacity-90 transition-opacity"
        >
            Back to Explore
        </Link>
      </div>
    );
  }

  if (loading || shouldBeLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="page-container">
        <SEOHead 
          title="User Not Found" 
          description="The user you are looking for does not exist or has been deleted." 
          noindex={true} 
        />
        <div className="content-wrapper py-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">User not found</h1>
          </div>
        </div>
      </div>
    );
  }

  // Fix 2: Handle null specializations
  const userSpecializations = user.skills || [];

  const handleModalClose = () => {
    if (active_tab && id) {
      navigate(`/profile/${id}/${active_tab}`);
    }
  };

  const handleAvailabilityToggle = () => {
    // Logic moved to component, but kept for interface compatibility if needed
  };



  return (
    <div ref={containerRef} className="pb-20">
      {/* Public Navigation for non-authenticated users */}
      {!isAuthenticated && <GuestHeader />}

      <div className={!isAuthenticated ? 'pt-20 max-w-7xl mx-auto px-4 md:px-8' : 'max-w-7xl mx-auto px-4 md:px-8 pt-6'}>
      {/* SEO Meta Tags */}
      <SEOHead
        title={`${user.first_name} ${user.last_name} - ${user.user_type === 'creator' ? 'Photographer' : user.user_type === 'model' ? 'Model' : 'Creative Professional'} Portfolio`}
        description={user.bio || `Explore ${user.first_name} ${user.last_name}'s professional portfolio on ClickCollab. ${user.user_type === 'creator' ? 'Hire this talented photographer for your next project.' : user.user_type === 'model' ? 'Book this model for your next shoot.' : 'Connect and collaborate.'} ${user.location ? `Based in ${user.location}.` : ''} View work, read reviews, and collaborate on ClickCollab - the #1 platform for photographers and models.`}
        image={resolveImageUrl(user.profile_pic)}
        url={typeof window !== 'undefined' ? window.location.href : ''}
        type="profile"
        keywords={[
          user.user_type === 'creator' ? 'photographer' : user.user_type === 'model' ? 'model' : 'creative',
          ...userSpecializations.map(s => s.name),
          user.location ? `${user.user_type === 'creator' ? 'photographer' : 'model'} in ${user.location}` : '',
          user.location || '',
          'portfolio',
          'creative professional',
          user.user_type === 'creator' ? 'hire photographer' : 'book model',
          user.user_type === 'creator' ? 'photography services' : 'modeling services',
          'collaboration',
          'professional portfolio',
          `${user.first_name} ${user.last_name} portfolio`
        ].filter(Boolean)}
        author={`${user.first_name} ${user.last_name}`}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Person',
          name: `${user.first_name} ${user.last_name}`,
          jobTitle: user.user_type === 'creator' ? 'Photographer' : user.user_type === 'model' ? 'Model' : 'Creative Professional',
          url: typeof window !== 'undefined' ? window.location.href : '',
          image: user.profile_pic,
          description: user.bio,
          address: user.location ? { '@type': 'PostalAddress', addressLocality: user.location } : undefined
        }}
      />
      {/* Cover Photo */}
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="cover-photo-container h-48 md:h-80 rounded-none md:rounded-3xl overflow-hidden mb-8 group relative z-0 -mx-4 md:mx-0" 
            >
        {/* Cover Image */}
      <div className="h-32 md:h-64 w-full relative group">
        {user.cover_photo ? (
          <SmartImage
            src={user.cover_photo_medium_signed || getOptimizedImageUrl(user.cover_photo, 'medium')}
            alt="Cover"
            className="w-full h-full object-cover"
            showOfflinePlaceholder={true}
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-r from-gray-200 to-gray-300"></div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60"></div>
            
            {isOwnProfile && (
                <>
                {user.cover_photo && (
                  <button
                      onClick={() => handleDeletePhoto('cover')}
                      className="absolute top-4 left-4 bg-white/90 dark:bg-gray-800/90 backdrop-blur-md p-2.5 rounded-xl hover:bg-red-50 dark:hover:bg-red-900/30 text-gray-700 dark:text-gray-300 hover:text-red-600 dark:hover:text-red-400 transition-colors z-10 shadow-sm"
                      title="Delete Cover Photo"
                  >
                      <TrashIcon className="h-5 w-5" />
                  </button>
                )}
                <button
                    onClick={() => setShowCoverPhotoModal(true)}
                    className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100"
                >
                    <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-md px-6 py-3 rounded-full flex items-center gap-2 shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-all">
                      <CameraIcon className="h-5 w-5 text-gray-900 dark:text-white" />
                      <span className="font-semibold text-gray-900 dark:text-white">Change Cover</span>
                    </div>
                </button>
                  <button
                    onClick={() => navigate("/profile/edit")}
                    className="absolute top-4 right-4 flex items-center px-4 py-1.5 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-full text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:border-gray-400 dark:hover:border-gray-500 transition-all shadow-sm"
                  >
                    <PencilIcon className="h-3 w-3 mr-1.5" />
                    Edit Profile
                  </button>
                </>
            )}
            
            {/* Share Button (Visible to everyone) */}

            </div>
            </motion.div>

        {/* Share Modal */}
        {user && (
            <ShareModal
                isOpen={showShareModal}
                onClose={() => setShowShareModal(false)}
                title={`${user.first_name} ${user.last_name}`}
                url={`${window.location.origin}/profile/${user.id}`}
                type="profile"
                data={user}
            />
        )}

        {/* Profile Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="relative z-10 -mt-28 md:-mt-32 mb-8 px-4 md:px-8"
        >
          <div className="flex flex-col md:flex-row md:items-end md:space-x-6">
            {/* Profile Picture */}
            <div className="relative mb-4 md:mb-0 group rounded-full flex-shrink-0 mx-auto md:mx-0 cursor-pointer">
                <Avatar 
                    src={user.profile_pic_thumb_signed || user.profile_pic} 
                    alt={`${user.first_name} ${user.last_name}`}
                    size="xl"
                    className="border-4 border-white dark:border-gray-800 bg-gray-100 dark:bg-gray-700 shadow-xl w-24 h-24 md:w-32 md:h-32 hover:scale-105 transition-all duration-300"
                    isDeleted={!!user.deleted_at || !!user.deletion_scheduled_at}
                    onClick={() => user.profile_pic && setShowFullProfilePic(true)}
                />
                {isOwnProfile && (
                    <>
                    {user.profile_pic && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeletePhoto('profile');
                        }}
                        className="absolute bottom-2 right-2 bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 transition-colors z-20 border border-gray-100 dark:border-gray-700"
                        title="Delete Profile Photo"
                      >
                        <TrashIcon className="h-4 w-4" />
                      </button>
                    )}
                    <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowProfilePhotoModal(true);
                    }}
                    className="absolute inset-0 bg-black/40 hover:bg-black/50 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100 rounded-full backdrop-blur-[2px]"
                    >
                        <CameraIcon className="h-8 w-8 text-white" />
                    </button>
                    </>
                )}
            </div>

            {/* Profile Info */}
            <div className="flex-1 pb-2 text-center md:text-left bg-white/90 dark:bg-gray-800/90 backdrop-blur-md rounded-2xl p-4 md:p-6 shadow-sm border border-white/20 dark:border-gray-700">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div>
                  <div className="flex items-center justify-center md:justify-start gap-2 mb-1">
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white tracking-tight">
                      {user.first_name} {user.last_name}
                    </h1>
                    {user?.subscription_tier === 'premium' && (
                      <div className="bg-black dark:bg-white text-white dark:text-black p-1 rounded-full shadow-sm" title="Verified Premium Member">
                        <CheckBadgeIcon className="h-5 w-5" />
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-center md:justify-start gap-2.5 text-gray-600 dark:text-gray-400 mb-3 text-sm flex-wrap">
                    <div className="flex items-center bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-full">
                      {user.user_type === 'creator' ? (
                        <CameraIcon className="h-4 w-4 mr-1.5 text-gray-900 dark:text-white flex-shrink-0" />
                      ) : (
                        <UserIcon className="h-4 w-4 mr-1.5 text-gray-900 dark:text-white flex-shrink-0" />
                      )}
                      <span className="font-semibold text-gray-900 dark:text-white">
                        {getUserRoleLabel(user)}
                      </span>
                    </div>

                    {user.experience && (
                      <div className="flex items-center bg-teal-50 dark:bg-teal-950/20 text-teal-700 dark:text-teal-300 px-3 py-1 rounded-full text-xs font-semibold border border-teal-100/50 dark:border-teal-900/30 capitalize">
                        {user.experience}
                      </div>
                    )}
                    
                    {(user.rating ?? 0) > 0 && (
                      <div className="flex items-center gap-1.5 bg-gray-50 dark:bg-gray-700 px-3 py-1 rounded-full border border-gray-100 dark:border-gray-600">
                        <StarIcon className="h-4 w-4 text-black dark:text-white fill-current" />
                        <span className="font-bold text-gray-900 dark:text-white">{user.rating!.toFixed(1)}</span>
                        <span className="text-gray-400 dark:text-gray-500 text-xs">({user.review_count || 0})</span>
                      </div>
                    )}

                    {/* Location moved here */}
                    <div className="relative flex justify-center md:justify-start items-center">
                        <div className={`flex items-center gap-2 text-gray-500 dark:text-gray-400 text-sm ${!currentUser ? 'filter blur-sm select-none' : ''}`}>
                          {user.location && (
                            <LocationText 
                              value={user.location}
                              className="text-sm font-medium"
                              iconClassName="h-4 w-4 mr-1.5 text-gray-400"
                            />
                          )}
                        </div>
                        
                        {!currentUser && (
                          <div className="absolute inset-0 flex items-center justify-center bg-gray-900/10 backdrop-blur-sm rounded-lg">
                            <Link to="/login">
                              <Button variant="primary" size="sm" className="shadow-lg text-xs py-1.5 h-8 bg-gray-900 hover:bg-gray-800 text-white">
                                <LockClosedIcon className="h-3.5 w-3.5 mr-1.5" />
                                Login to view
                              </Button>
                            </Link>
                          </div>
                        )}
                    </div>
                  </div>
                  
                  {/* Available Cities */}
                  {user.user_type !== 'hirer' && user.available_cities && user.available_cities.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-2 justify-center md:justify-start items-center">
                      {(showAllCities ? user.available_cities : user.available_cities.slice(0, 2)).map((city, index) => (
                        <div 
                           key={index}
                           className="flex items-center text-xs font-medium text-gray-600 dark:text-gray-400 bg-gray-100 dark:bg-gray-700/50 px-2.5 py-1 rounded-full border border-gray-200 dark:border-gray-600"
                        >
                          <MapPinIcon className="h-3 w-3 mr-1 text-gray-400 dark:text-gray-500" />
                          {city.city_name}
                        </div>
                      ))}
                      {!showAllCities && user.available_cities.length > 2 && (
                        <button 
                          onClick={() => setShowAllCities(true)}
                          className="flex items-center text-xs font-semibold text-primary-600 bg-primary-50 dark:bg-primary-900/30 dark:text-primary-400 px-2 py-1 rounded-full border border-primary-100 dark:border-primary-800 cursor-pointer hover:bg-primary-100 dark:hover:bg-primary-900/50 transition-colors"
                        >
                          +{user.available_cities.length - 2}
                        </button>
                      )}
                      {showAllCities && user.available_cities.length > 2 && (
                        <button 
                          onClick={() => setShowAllCities(false)}
                          className="flex items-center text-xs font-semibold text-gray-500 bg-gray-50 px-2 py-1 rounded-full border border-gray-100 cursor-pointer hover:bg-gray-100 transition-colors"
                        >
                          Show Less
                        </button>
                      )}
                    </div>
                  )}
                </div>

                {/* Enhanced Action Buttons */}
                <div className="flex items-center justify-center gap-3 mt-4 md:mt-0">
                  {isOwnProfile ? (
                    <>
                    {/* <Link to="/profile/edit" className="hidden md:block">
                      <Button variant="outline" className="flex items-center gap-2 rounded-xl border-gray-200 hover:border-gray-900 hover:bg-gray-50 text-gray-900">
                        <PencilIcon className="h-4 w-4" />
                        <span>Edit Profile</span>
                      </Button>
                    </Link> */}
                    <Button
                        variant="outline"
                        size="icon"
                        onClick={handleShare}
                        className="rounded-xl border-2 border-gray-100 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-orange-500 dark:hover:border-orange-500 hover:text-orange-600 dark:hover:text-orange-400 hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-all duration-200"
                        title="Share Profile"
                    >
                        <ShareIcon className="h-5 w-5" />
                    </Button>
                    <Link to="/dashboard">
                      <Button
                          variant="outline"
                          size="icon"
                          className="rounded-xl border-2 border-gray-100 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-orange-500 dark:hover:border-orange-500 hover:text-orange-600 dark:hover:text-orange-400 hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-all duration-200"
                          title="Dashboard"
                      >
                          <HomeIcon className="h-5 w-5" />
                      </Button>
                    </Link>
                    </>
                  ) : (
                    <>
                      {!currentUser ? (
                        <Button 
                          variant="primary" 
                          className="rounded-xl shadow-lg shadow-black/20 px-6 py-2.5 font-bold tracking-wide"
                          onClick={() => setShowLoginModal(true)}
                        >
                          Login to Connect
                        </Button>
                      ) : (
                        <>
                          {renderCollaborationButton()}

                          {user?.is_collaborator && (
                            <Button
                              variant="outline"
                              size="icon"
                              onClick={handleMessage}
                              loading={isMessaging}
                              className="rounded-xl border-2 border-gray-100 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-orange-500 dark:hover:border-orange-500 hover:text-orange-600 dark:hover:text-orange-400 hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-all duration-200"
                              title="Message"
                            >
                              <ChatBubbleLeftIcon className="h-5 w-5" />
                            </Button>
                          )}

                          <Button
                            variant={isFollowingUser ? "outline" : "primary"}
                            size="icon"
                            onClick={handleFollowToggle}
                            loading={followLoading || checkingFollowStatus}
                            className={`rounded-xl border-2 flex items-center justify-center transition-all duration-200 ${
                              isFollowingUser 
                                ? 'border-gray-200 dark:border-gray-700 text-gray-900 dark:text-white hover:bg-red-500 dark:hover:bg-red-900/30 hover:text-red-600 dark:hover:text-red-400 hover:border-red-600 dark:hover:border-red-400' 
                                : 'border-transparent bg-black dark:bg-white text-white dark:text-black hover:bg-gray-800 dark:hover:bg-gray-200 shadow-lg shadow-black/20'
                            }`}
                            title={isFollowingUser ? "Unfollow" : "Follow"}
                          >
                            {checkingFollowStatus ? (
                              <div className="w-5 h-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
                            ) : isFollowingUser ? (
                              <UserMinusIcon className="h-5 w-5" />
                            ) : (
                              <UserPlusIcon className="h-5 w-5" />
                            )}
                          </Button>

                          <Button
                            variant="outline"
                            size="icon"
                            onClick={handleShare}
                            loading={isSharing}
                            className="rounded-xl border-2 border-gray-100 dark:border-gray-700 text-gray-600 dark:text-gray-400 hover:border-orange-500 dark:hover:border-orange-500 hover:text-orange-600 dark:hover:text-orange-400 hover:bg-orange-50 dark:hover:bg-orange-900/20 transition-all duration-200"
                            title="Share Profile"
                          >
                            <ShareIcon className="h-5 w-5" />
                          </Button>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Stats Bar - Horizontal (Only shown for own profile) */}
        {isOwnProfile && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-6 px-4 md:px-0 mt-8"
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-2 md:p-6 flex flex-nowrap justify-between items-center divide-x divide-gray-100 dark:divide-gray-700 overflow-x-auto no-scrollbar">
              <button
                onClick={() => currentUser && handleShowRelationships('followers')}
                className={`flex-1 flex flex-col items-center px-1 md:px-4 min-w-[70px] transition-all ${currentUser ? 'hover:scale-105 cursor-pointer' : 'cursor-default'}`}
              >
                <span className="text-base md:text-3xl font-bold text-gray-900 dark:text-white">{user?.followers_count || 0}</span>
                <span className="text-[9px] md:text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mt-0.5 md:mt-1 truncate w-full text-center">Followers</span>
              </button>
              
              <button
                onClick={() => currentUser && handleShowRelationships('following')}
                className={`flex-1 flex flex-col items-center px-1 md:px-4 min-w-[70px] transition-all ${currentUser ? 'hover:scale-105 cursor-pointer' : 'cursor-default'}`}
              >
                <span className="text-base md:text-3xl font-bold text-gray-900 dark:text-white">{user?.following_count || 0}</span>
                <span className="text-[9px] md:text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider mt-0.5 md:mt-1 truncate w-full text-center">Following</span>
              </button>
            </div>
          </motion.div>
        )}

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-8 mb-8 px-4 md:px-0 mt-8">
          {/* Left Column: About & Bio */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="lg:col-span-2"
          >
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 md:p-6 h-full">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center">
                  <UserIcon className="h-5 w-5 mr-2 text-primary-500" />
                  About
                </h2>
              </div>
              
              {user.bio ? (
                <div className="prose prose-base max-w-none text-gray-600 dark:text-gray-300 leading-relaxed whitespace-pre-line">
                  {user.bio}
                </div>
              ) : (
                <div className="text-center py-8 bg-gray-50 dark:bg-gray-700 rounded-lg border border-dashed border-gray-200 dark:border-gray-600">
                  <p className="text-gray-500 dark:text-gray-400 text-sm">No bio available.</p>
                </div>
              )}
            </div>
          </motion.div>

          {/* Right Column: Contact & Details */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="space-y-6"
          >
            {/* Projects Card beside About */}
            <div
              onClick={() => navigate(`/profile/${id || user.id}/projects`)}
              className="relative overflow-hidden bg-gradient-to-br from-white via-white to-primary-50/30 dark:from-gray-800 dark:via-gray-800 dark:to-gray-800/90 rounded-2xl shadow-sm hover:shadow-md border border-gray-200/80 dark:border-gray-700/80 p-5 cursor-pointer transition-all duration-300 group hover:border-primary-300 dark:hover:border-primary-700"
            >
              {/* Subtle background glow */}
              <div className="absolute -right-4 -bottom-4 w-20 h-20 bg-primary-500/5 rounded-full blur-lg group-hover:bg-primary-500/10 transition-all pointer-events-none" />

              <div className="flex items-center justify-between relative z-10">
                <div className="flex items-center gap-4">
                  {/* Icon Badge */}
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-tr from-primary-500 to-orange-400 text-white flex items-center justify-center shadow-md shadow-primary-500/20 group-hover:scale-105 group-hover:rotate-2 transition-transform duration-300 flex-shrink-0">
                    <FolderIcon className="w-6 h-6 stroke-[2]" />
                  </div>
                  <div>
                    <h3 className="text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest">
                      Projects
                    </h3>
                    <div className="flex items-baseline gap-2 mt-0.5">
                      <span className="text-2xl md:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
                        {userCollaborations?.length ?? (user as any)?.project_count ?? user?.collaboration_count ?? 0}
                      </span>
                      <span className="text-xs font-semibold text-gray-500 dark:text-gray-400">
                        {(userCollaborations?.length ?? (user as any)?.project_count ?? user?.collaboration_count ?? 0) === 1 ? 'project' : 'projects'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Action CTA */}
                <div className="flex items-center gap-1.5 text-xs font-bold text-primary-600 dark:text-primary-400 group-hover:text-primary-700 dark:group-hover:text-primary-300 bg-primary-50 dark:bg-primary-950/50 px-3.5 py-2 rounded-xl border border-primary-100 dark:border-primary-900/40 transition-colors flex-shrink-0">
                  <span>View all</span>
                  <ChevronRightIcon className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform duration-200" />
                </div>
              </div>
            </div>

            {/* Instagram Profile Card (Shown when instagram handle, token, or API profile data exists) */}
            {/* {(user.instagram_handle || user.instagram_access_token || igProfileData?.username) && (() => {
              const rawHandle = igProfileData?.username || user.instagram_handle || '';
              let cleanIgHandle = rawHandle.replace(/^@/, '').trim();
              if (cleanIgHandle.includes('@')) {
                cleanIgHandle = cleanIgHandle.split('@')[0];
              }
              const displayIgName = igProfileData?.name || `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Instagram Creator';
              const displayIgPic = igProfileData?.profile_picture_url || user.profile_pic_thumb_signed || user.profile_pic_signed || user.profile_pic || 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200';
              const followers = igProfileData?.followers_count ?? user.followers_count ?? 0;
              const posts = igProfileData?.media_count ?? userCollaborations?.length ?? (user as any)?.project_count ?? portfolio?.length ?? 0;

              return (
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-5 relative overflow-hidden">
                  {/* Instagram Gradient Header Line *}
                  <div className="h-1.5 bg-gradient-to-r from-yellow-500 via-red-500 to-purple-600 absolute top-0 left-0 right-0" />
                  
                  <div className="flex items-center justify-between mb-4 pt-1 gap-2">
                    <div className="flex items-center gap-2 min-w-0">
                      <div className="p-1.5 rounded-lg bg-gradient-to-tr from-yellow-500 via-red-500 to-purple-600 text-white shrink-0">
                        <InstagramIcon className="w-4 h-4" />
                      </div>
                      <h3 className="text-xs font-bold text-gray-900 dark:text-white uppercase tracking-wider truncate">
                        Instagram Integration
                      </h3>
                    </div>
                    {cleanIgHandle && (
                      <a
                        href={`https://instagram.com/${cleanIgHandle}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs font-semibold text-pink-600 dark:text-pink-400 hover:underline flex items-center gap-1 shrink-0"
                      >
                        <span>@{cleanIgHandle}</span>
                        <ArrowTopRightOnSquareIcon className="w-3.5 h-3.5" />
                      </a>
                    )}
                  </div>

                  {/* Details Section *}
                  <div className="flex items-center gap-3.5 bg-gray-50 dark:bg-gray-750/50 p-3.5 rounded-xl border border-gray-100 dark:border-gray-700/80">
                    <div className="relative p-0.5 rounded-full bg-gradient-to-tr from-yellow-500 via-red-500 to-purple-600 flex-shrink-0">
                      <img
                        src={displayIgPic}
                        alt={displayIgName}
                        className="w-11 h-11 rounded-full object-cover border-2 border-white dark:border-gray-800"
                      />
                    </div>

                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-bold text-gray-900 dark:text-white truncate">
                        {displayIgName}
                      </p>
                      {cleanIgHandle && (
                        <p className="text-xs text-gray-500 dark:text-gray-400 truncate font-medium">
                          @{cleanIgHandle}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Stats Grid *}
                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <div className="p-3 bg-gray-50 dark:bg-gray-750/30 rounded-xl text-center border border-gray-100 dark:border-gray-750">
                      <span className="block text-lg font-extrabold text-gray-900 dark:text-white">
                        {followers}
                      </span>
                      <span className="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                        Followers
                      </span>
                    </div>

                    <div className="p-3 bg-gray-50 dark:bg-gray-750/30 rounded-xl text-center border border-gray-100 dark:border-gray-750">
                      <span className="block text-lg font-extrabold text-gray-900 dark:text-white">
                        {posts}
                      </span>
                      <span className="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
                        Posts
                      </span>
                    </div>
                  </div>
                </div>
              );
            })()} */}

            {/* Specializations Card - Hide for Hirer Users */}
            {user.user_type !== 'hirer' && userSpecializations.length > 0 && (
              <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 md:p-6">
                <h3 className="text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider mb-4">Specializations</h3>
                <div className="flex flex-wrap gap-2">
                  {userSpecializations.map((spec, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 text-xs font-medium bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full border border-gray-200 dark:border-gray-600"
                    >
                      {spec.name}
                    </span>
                  ))}
                </div>
              </div>
            )}



            {/* Profile Checklist Section */}
            {isOwnProfile && user && (
               <ProfileChecklist 
                 user={user} 
                 onAction={(action) => {
                   if (action === 'edit-profile') navigate('/profile/edit');
                   if (action === 'upload-photo') setShowProfilePhotoModal(true);
                   if (action === 'add-portfolio') setShowAddPortfolioModal(true);
                   if (action === 'create-collaboration') setShowCreateCollaboration(true);
                   if (action === 'edit-model-specs') setShowEditModelSpecsModal(true);
                 }}
               />
            )}
          </motion.div>
        </div>

        {/* Model Specifications Section (Full-Width) */}
        {user.user_type === 'model' && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 mb-8 mx-4 md:mx-0"
          >
            <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-100 dark:border-gray-700 pb-4 mb-6 gap-3">
              <h3 className="text-lg font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center">
                <SparklesIcon className="h-5 w-5 mr-2 text-teal-500" />
                Model Specifications
              </h3>
              <div className="flex items-center gap-2">
                {user.model_profile && (
                  <button
                    onClick={() => setShowCompCardModal(true)}
                    className="flex items-center gap-1.5 px-4 py-2 bg-gray-900 hover:bg-black dark:bg-white dark:hover:bg-gray-100 text-white dark:text-black font-semibold text-xs rounded-xl transition-all shadow-sm whitespace-nowrap"
                  >
                    <IdentificationIcon className="h-4 w-4" />
                    View Comp Card
                  </button>
                )}
                {isOwnProfile && (
                  <button
                    onClick={() => setShowEditModelSpecsModal(true)}
                    className="flex items-center gap-1.5 px-3 py-2 text-xs font-semibold text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-750 rounded-xl border border-gray-200 dark:border-gray-750 transition-colors whitespace-nowrap"
                  >
                    <PencilIcon className="h-3.5 w-3.5" />
                    {user.model_profile ? 'Edit' : 'Set Specifications'}
                  </button>
                )}
              </div>
            </div>

            {user.model_profile ? (
              <div className="space-y-6">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                  {/* Height */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Height</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">
                      {user.model_profile.height ? `${user.model_profile.height} cm (${Math.floor((user.model_profile.height / 2.54) / 12)}'${Math.round((user.model_profile.height / 2.54) % 12)}")` : '—'}
                    </span>
                  </div>

                  {/* Weight */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Weight</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">
                      {user.model_profile.weight ? `${user.model_profile.weight} kg (${Math.round(user.model_profile.weight * 2.20462)} lbs)` : '—'}
                    </span>
                  </div>

                  {/* Measurements */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Measurements</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">
                      {user.model_profile.bust && user.model_profile.waist && user.model_profile.hips 
                        ? `${user.model_profile.bust}-${user.model_profile.waist}-${user.model_profile.hips} cm (${Math.round(user.model_profile.bust / 2.54)}-${Math.round(user.model_profile.waist / 2.54)}-${Math.round(user.model_profile.hips / 2.54)}")`
                        : '—'}
                    </span>
                  </div>

                  {/* Shoe Size */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Shoe Size</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">
                      {user.model_profile.shoe_size || '—'}
                    </span>
                  </div>

                  {/* Dress Size */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Dress Size</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">
                      {user.model_profile.dress_size || '—'}
                    </span>
                  </div>

                  {/* Hair / Eye Color */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Hair / Eyes</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1 capitalize">
                      {user.model_profile.hair_color && user.model_profile.eye_color 
                        ? `${user.model_profile.hair_color} / ${user.model_profile.eye_color}` 
                        : '—'}
                    </span>
                  </div>

                  {/* Gender / Ethnicity */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Gender / Ethnicity</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1 capitalize">
                      {user.model_profile.gender && user.model_profile.ethnicity 
                        ? `${user.model_profile.gender} / ${user.model_profile.ethnicity}` 
                        : '—'}
                    </span>
                  </div>

                  {/* Agency */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Agency</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1 truncate" title={user.model_profile.agency_represented && user.model_profile.agency_name ? user.model_profile.agency_name : 'Freelance'}>
                      {user.model_profile.agency_represented && user.model_profile.agency_name 
                        ? user.model_profile.agency_name 
                        : 'Freelance / Unrepresented'}
                    </span>
                  </div>

                  {/* Accepts */}
                  <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                    <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Accepts</span>
                    <span className="text-sm font-bold text-gray-900 dark:text-white mt-1 capitalize">
                      {[
                        user.model_profile.accepts_paid !== false ? 'Paid' : null,
                        user.model_profile.accepts_tfp !== false ? 'TFP' : null
                      ].filter(Boolean).join(' / ') || '—'}
                    </span>
                  </div>

                  {/* Est. Rates */}
                  {(user.model_profile.half_day_rate || user.model_profile.full_day_rate) ? (
                    <div className="col-span-2 sm:col-span-3 md:col-span-1 bg-gradient-to-r from-teal-500/10 to-emerald-500/10 dark:from-teal-950/20 dark:to-emerald-950/20 p-4 rounded-xl border border-teal-100/50 dark:border-teal-900/20 flex flex-col justify-between">
                      <span className="text-xs font-semibold text-teal-800 dark:text-teal-300 uppercase tracking-wider">Est. Rates</span>
                      <div className="flex flex-col mt-1 text-xs text-gray-900 dark:text-white font-bold leading-tight">
                        {user.model_profile.half_day_rate && <div>Half (4h): ₹{user.model_profile.half_day_rate.toLocaleString()}</div>}
                        {user.model_profile.full_day_rate && <div className="mt-0.5">Full (8h): ₹{user.model_profile.full_day_rate.toLocaleString()}</div>}
                      </div>
                    </div>
                  ) : (
                    <div className="bg-gray-50/50 dark:bg-gray-900/30 p-4 rounded-xl border border-gray-100/50 dark:border-gray-800 flex flex-col justify-between">
                      <span className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider">Rates</span>
                      <span className="text-sm font-bold text-gray-900 dark:text-white mt-1">—</span>
                    </div>
                  )}
                </div>


              </div>
            ) : (
              <div className="text-center py-8 bg-gray-50 dark:bg-gray-900 rounded-xl border border-dashed border-gray-200 dark:border-gray-700">
                <p className="text-gray-500 dark:text-gray-400 text-sm mb-3">No model specifications configured yet.</p>
                {isOwnProfile && (
                  <button
                    onClick={() => setShowEditModelSpecsModal(true)}
                    className="px-5 py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-xl text-sm font-bold transition-all shadow-sm"
                  >
                    Set Specifications
                  </button>
                )}
              </div>
            )}
          </motion.div>
        )}

        {/* Content Tabs */}
      <div className="-mx-4 md:mx-0 mt-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="min-h-[500px]"
        >

          {/* Tab Navigation */}
          <div ref={tabsRef} className="w-full max-w-full overflow-x-auto no-scrollbar border-b border-gray-100 dark:border-gray-700 mb-8">
            <nav className="flex w-full space-x-0 px-4 md:px-0">

              {user.user_type !== 'hirer' && (
              <button
                onClick={() => navigate(`/profile/${id || user.id}/portfolio`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'portfolio'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                Portfolio
              </button>
              )}

              {/* {user.user_type !== 'hirer' && (
              <button
                onClick={() => navigate(`/profile/${id || user.id}/showcase`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'showcase'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                <PhotoIcon className="h-3.5 w-3.5 mr-1.5 inline" />
                Showcase
              </button>
              )} */}

              <button
                onClick={() => navigate(`/profile/${id || user.id}/projects`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'projects'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                <UsersIcon className="h-3.5 w-3.5 mr-1.5 inline" />
                Projects
              </button>

              {user.user_type !== 'hirer' && (
              <button
                onClick={() => navigate(`/profile/${id || user.id}/services`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'services'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                <CheckBadgeIcon className="h-3.5 w-3.5 mr-1.5 inline" />
                Services
              </button>
              )}
              
              {user.user_type !== 'hirer' && (
               <button
                onClick={() => navigate(`/profile/${id || user.id}/reviews`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'reviews'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                Reviews
              </button>
              )}

              {user.user_type === 'model' && (
                <button
                  onClick={() => navigate(`/profile/${id || user.id}/digitals`)}
                  className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                    activeTab === 'digitals'
                      ? 'border-black dark:border-white text-black dark:text-white'
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                  }`}
                >
                  Digitals
                </button>
              )}

              {user.user_type === 'hirer' && isOwnProfile && (
              <button
                onClick={() => navigate(`/profile/${id || user.id}/my-projects`)}
                className={`flex-1 justify-center py-2 md:py-3 px-3 border-b-2 font-medium text-xs md:text-sm whitespace-nowrap transition-all ${
                  activeTab === 'my-projects'
                    ? 'border-black dark:border-white text-black dark:text-white'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-200 dark:hover:border-gray-600'
                }`}
              >
                My Bookings
              </button>
              )}
            </nav>
          </div>




          {/* Tab Content */}

          {activeTab === 'portfolio' && user.user_type !== 'hirer' && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              // className="w-full max-w-full min-w-0"
            >
              <div id='portfolio' className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden mb-10 mx-4 md:mx-0">
                  <div className="p-4 md:p-6 border-b border-gray-100 dark:border-gray-700">
                    {/* Top Header Row */}
                    <div className="flex items-center justify-between gap-2 flex-wrap min-w-0">
                      <div className="flex items-center gap-2 flex-wrap min-w-0">
                        <h2 className="text-lg font-bold text-gray-900 dark:text-white">Portfolio</h2>
                        
                        {/* Subtab Toggle (Photos / Videos) */}
                        <div className="flex bg-gray-100 dark:bg-gray-900 p-0.5 rounded-lg border border-gray-200/50 dark:border-gray-800">
                          <button
                            onClick={() => setPortfolioSubTab('photos')}
                            className={`px-2.5 py-1 text-xs font-bold rounded-md transition-all ${
                              portfolioSubTab === 'photos'
                                ? 'bg-white dark:bg-gray-800 text-teal-600 dark:text-teal-400 shadow-sm'
                                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
                            }`}
                          >
                            Photos
                          </button>
                          <button
                            onClick={() => setPortfolioSubTab('videos')}
                            className={`px-2.5 py-1 text-xs font-bold rounded-md transition-all ${
                              portfolioSubTab === 'videos'
                                ? 'bg-white dark:bg-gray-800 text-teal-600 dark:text-teal-400 shadow-sm'
                                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
                            }`}
                          >
                            Videos
                          </button>
                        </div>

                        {/* Set Default Subtab Badge (Owner Only) */}
                        {isOwnProfile && user?.default_portfolio_tab !== portfolioSubTab && (
                          <button
                            onClick={handleSetDefaultTab}
                            className="text-[10px] font-bold uppercase tracking-wider text-teal-600 dark:text-teal-400 bg-teal-50 dark:bg-teal-950/40 hover:bg-teal-100 px-2 py-1 rounded border border-teal-200/60 dark:border-teal-800/60 transition"
                            title={`Make ${portfolioSubTab} your default tab`}
                          >
                            Set Default
                          </button>
                        )}
                      </div>

                      {/* Item/Folder Count Badge */}
                      <span className="text-xs font-medium text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-900 px-2.5 py-1 rounded-full border border-gray-200/50 dark:border-gray-800 shrink-0">
                        {portfolioViewMode === 'grid' || !isOwnProfile || portfolioSubTab === 'videos'
                          ? `${portfolio.length} ${portfolio.length === 1 ? 'item' : 'items'}`
                          : `${portfolioFolders.length} ${portfolioFolders.length === 1 ? 'folder' : 'folders'}`
                        }
                      </span>
                    </div>

                    {/* Folder Breadcrumb */}
                    {folder_id && selectedFolder && (
                      <button 
                        onClick={() => navigate(`/profile/${id || currentUser?.id}/portfolio`)}
                        className="text-xs font-medium text-primary-600 hover:text-primary-700 flex items-center mt-2"
                      >
                        <ArrowLeftIcon className="h-3 w-3 mr-1" />
                        Back to Folders / {selectedFolder.name}
                      </button>
                    )}

                    {/* Secondary Toolbar Row */}
                    {!folder_id && (isOwnProfile || portfolioFolders.length > 0) && (
                      <div className="flex flex-wrap items-center justify-between gap-2.5 pt-3 mt-3 border-t border-gray-100 dark:border-gray-700/60 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap min-w-0">
                          <div className="flex items-center bg-gray-100 dark:bg-gray-900 rounded-lg p-0.5 border border-gray-200/50 dark:border-gray-800">
                            <button
                              onClick={() => setPortfolioViewMode('folders')}
                              className={`px-2.5 py-1 text-xs font-semibold rounded-md transition-colors ${
                                portfolioViewMode === 'folders'
                                  ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-sm'
                                  : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
                              }`}
                            >
                              Folders
                            </button>
                            <button
                              onClick={() => setPortfolioViewMode('grid')}
                              className={`px-2.5 py-1 text-xs font-semibold rounded-md transition-colors ${
                                portfolioViewMode === 'grid'
                                  ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-sm'
                                  : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
                              }`}
                            >
                              Grid
                            </button>
                          </div>

                          {isOwnProfile && user?.default_portfolio_view !== portfolioViewMode && (
                            <button
                              onClick={handleSetDefaultView}
                              className="text-[10px] font-bold uppercase tracking-wider text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-950/40 hover:bg-primary-100 px-2 py-1 rounded border border-primary-200/60 dark:border-primary-800/60 transition"
                              title={`Make ${portfolioViewMode} your default view`}
                            >
                              Set Default
                            </button>
                          )}
                        </div>

                        {isOwnProfile && IS_INSTAGRAM_SYNC_ENABLED && (
                          <button
                            onClick={handleInstagramSyncClick}
                            className="px-3 py-1.5 text-xs font-semibold text-white bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:opacity-90 rounded-lg flex items-center gap-1.5 transition shadow-sm whitespace-nowrap shrink-0"
                          >
                            <InstagramIcon className="w-3.5 h-3.5 shrink-0" />
                            <span>Sync Instagram</span>
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                {/* Tag Filter (Only show in Grid mode and NOT in a folder) */}
                {/* {portfolioViewMode === 'grid' && !folder_id && availableTags.length > 0 && (
                    <div className="w-full max-w-full min-w-0 overflow-x-auto no-scrollbar border-b border-gray-100 dark:border-gray-700">
                        <div className="px-4 md:px-6 py-3 flex items-center gap-2 w-max">
                            {availableTags.map(tag => (
                                <button
                                    key={tag}
                                    onClick={() => toggleTag(tag)}
                                    className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap shrink-0 border ${
                                        selectedTags.includes(tag)
                                            ? 'bg-black dark:bg-white text-white dark:text-black border-black dark:border-white'
                                            : 'bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500'
                                    }`}
                                >
                                    {tag}
                                </button>
                            ))}
                        </div>
                    </div>
                )} */}

                <div className="p-4 md:p-6 overflow-hidden">
                  {portfolioSubTab === 'videos' ? (
                    <VideoSection userId={user.id} isOwnProfile={isOwnProfile} onSyncInstagram={IS_INSTAGRAM_SYNC_ENABLED ? handleInstagramSyncClick : undefined} />
                  ) : portfolioViewMode === 'folders' ? (
                    foldersLoading ? (
                      <div className="flex justify-center py-12">
                        <ArrowPathIcon className="h-8 w-8 animate-spin text-gray-400" />
                      </div>
                    ) : (
                      <PortfolioFolderGrid
                        folders={isOwnProfile ? portfolioFolders : portfolioFolders.filter(f => (f.item_count || 0) > 0)}
                        isOwner={isOwnProfile}
                        onCreateClick={() => {
                          setEditingFolder(null);
                          setShowCreateFolderModal(true);
                        }}
                        onFolderClick={(folder) => {
                          setSelectedFolder(folder);
                          navigate(`/profile/${id || currentUser?.id}/portfolio/folders/${folder.id}`);
                        }}
                        onEditFolder={(folder) => {
                          setEditingFolder(folder);
                          setShowCreateFolderModal(true);
                        }}
                        onDeleteFolder={async (folder) => {
                          if (window.confirm('Are you sure you want to delete this folder? The images will not be deleted.')) {
                            try {
                              await userAPI.deletePortfolioFolder(folder.id);
                              setPortfolioFolders(prev => prev.filter(f => f.id !== folder.id));
                              toast.success('Folder deleted');
                            } catch (error) {
                              toast.error('Failed to delete folder');
                            }
                          }
                        }}
                      />
                    )
                  ) : (
                    <MasonryPortfolioGrid 
                      portfolio={portfolio}
                      loading={portfolioLoading}
                      hasMore={hasMorePortfolio}
                      onLoadMore={handleLoadMorePortfolio}
                      onPortfolioAdded={(newItem) => {
                        if (newItem && newItem.id) {
                          setPortfolio(prev => [newItem, ...prev]);
                        } else {
                          // Refresh whole folder/counts if newItem is empty (Select Existing flow)
                          setRefreshFolderTrigger(prev => prev + 1);
                        }
                      }}
                      isOwnProfile={isOwnProfile} 
                      onAddClick={() => setShowAddPortfolioModal(true)}
                      onSyncInstagram={isOwnProfile && IS_INSTAGRAM_SYNC_ENABLED ? handleInstagramSyncClick : undefined}
                      initialPortfolioId={item_id}
                      folderId={folder_id || undefined}
                    />
                  )}
                </div>
                </div>
            </motion.div>
            )}

          {activeTab === 'showcase' && user.user_type !== 'hirer' && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <ShowcaseTab 
                userId={id || user.id} 
                isOwnProfile={isOwnProfile} 
              />
            </motion.div>
          )}


          {activeTab === 'projects' && (

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
                    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden  mb-10 mx-4 md:mx-0">
                    <div className="p-4 md:p-6 border-b border-gray-100 dark:border-gray-700">
                        <div className="flex items-center justify-between">
                        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Projects</h2>
                        <div className="flex items-center space-x-4">
                            {/* <span className="text-sm text-gray-500">
                            {collaborations?.length || 0} {(collaborations?.length || 0) === 1 ? 'collaboration' : 'collaborations'}
                            </span> */}
                        </div>
                        </div>
                    </div>
                    
                    <div className="p-4 md:p-6">
                        <CollaborationGrid 
                          collaborations={userCollaborations || []} 
                          loading={collaborationsLoading}
                          selectedCollabId={item_id}
                          isOwnProfile={isOwnProfile}
                          onCreateCollaboration={isOwnProfile && user.user_type !== 'hirer' ? () => setShowCreateCollaboration(true) : undefined}
                          onSyncInstagram={isOwnProfile && user.user_type !== 'hirer' && IS_INSTAGRAM_SYNC_ENABLED ? () => handleInstagramSyncClick('project') : undefined}
                          onCloseModal={handleModalClose}
                          onSelect={(collabId) => navigate(`/profile/${id || user?.id}/projects/${collabId}`)}
                        />
                    </div>
                    </div>
                </motion.div>
                )}
            {activeTab === 'services' && user.user_type !== 'hirer' && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden mb-10 mx-4 md:mx-0">
                  <div className="p-4 md:p-6 border-b border-gray-100 dark:border-gray-700">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Services</h2>
                      <span className="text-xs text-gray-500 dark:text-gray-400">
                        {user.services_count || 0} {(user.services_count || 0) === 1 ? 'service' : 'services'}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-4 md:p-6">
                    <ServicePackagesList 
                      userId={user.id} 
                      isOwner={isOwnProfile} 
                      onBook={handleBookService}
                      onUpdate={() => {
                        if (user.id) {
                          dispatch(fetchUserProfile(user.id));
                        }
                      }}
                    />
                  </div>
                </div>
              </motion.div>
            )}

          {activeTab === 'reviews' && (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
            >
                <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden mb-10 mx-4 md:mx-0">
                  <div className="p-4 md:p-6 border-b border-gray-100 dark:border-gray-700">
                    <div className="flex items-center justify-between">
                      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Reviews</h2>
                      <span className="text-xs text-gray-500 dark:text-gray-400">
                        {user.review_count || 0} {(user.review_count || 0) === 1 ? 'review' : 'reviews'}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-4 md:p-6">
                    <ReviewsSection userId={user.id} highlightReviewId={item_id} />
                  </div>
                </div>
            </motion.div>
          )}

          {activeTab === 'my-projects' && user.user_type === 'hirer' && isOwnProfile && (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
            >
                <div className="mb-10 mx-4 md:mx-0">
                  <ClientPortal />
                </div>
            </motion.div>
          )}

          {activeTab === 'digitals' && user.user_type === 'model' && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 mx-4 md:mx-0 mb-10"
            >
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h3 className="text-lg font-bold text-gray-950 dark:text-white">Unedited Digitals / Polaroids</h3>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Raw, unretouched modeling shots for agencies and clients.</p>
                </div>
                {isOwnProfile && (
                  <button
                    onClick={() => setShowEditModelSpecsModal(true)}
                    className="px-4 py-2 border border-gray-200 dark:border-gray-700 hover:border-gray-300 rounded-xl text-xs font-bold text-gray-700 dark:text-gray-300 transition-all bg-white dark:bg-gray-900"
                  >
                    Manage Digitals
                  </button>
                )}
              </div>

              {user.model_profile?.digitals && user.model_profile.digitals.length > 0 ? (
                <Masonry
                  breakpointCols={{
                    default: 4,
                    1280: 3,
                    768: 2,
                    500: 3
                  }}
                  className="masonry-grid"
                  columnClassName="masonry-grid_column"
                >
                  {user.model_profile.digitals.map((url, idx) => (
                    <motion.div
                      key={url}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: idx * 0.05 }}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="group cursor-pointer relative mb-6 rounded-2xl overflow-hidden bg-gray-100 dark:bg-gray-800 shadow-sm hover:shadow-xl transition-all duration-500"
                      onClick={() => setSelectedDigitalIndex(idx)}
                    >
                      <SmartImage
                        src={resolveImageUrl(url)}
                        alt={`Digital Polaroid ${idx + 1}`}
                        className="w-full object-cover group-hover:scale-105 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                        <div>
                          <span className="text-[10px] text-teal-400 font-black uppercase tracking-widest block mb-1">Raw Digital</span>
                          <span className="text-white font-bold text-sm leading-tight">Digital Polaroid {idx + 1}</span>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </Masonry>
              ) : (
                <div className="text-center py-12 bg-gray-50 dark:bg-gray-900 rounded-2xl border border-dashed border-gray-200 dark:border-gray-700">
                  <PhotoIcon className="w-10 h-10 mx-auto text-gray-300 mb-3 animate-pulse" />
                  <p className="text-gray-500 dark:text-gray-400 text-sm mb-3">No unedited digitals uploaded yet.</p>
                  {isOwnProfile && (
                    <button
                      onClick={() => setShowEditModelSpecsModal(true)}
                      className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-xl text-xs font-bold transition-all shadow-sm"
                    >
                      Upload Digitals
                    </button>
                  )}
                </div>
              )}
            </motion.div>
          )}
        </motion.div>


        {/* Collaboration Request Modal */}
        {profileUser && (
          <CollaborationRequestModal
            isOpen={showCollaborationModal}
            onClose={() => setShowCollaborationModal(false)}
            receiver={profileUser}
            onSuccess={handleCollaborationSuccess}
            initialValues={collaborationInitialValues}
            isBooking={!!collaborationInitialValues}
          />
        )}

        {/* Collaboration Options Modal */}
        {profileUser && (
          <CollaborationOptionsModal
            isOpen={showCollaborationOptions}
            onClose={() => setShowCollaborationOptions(false)}
            user={profileUser}
            hasServices={(profileUser.services_count ?? 0) > 0 || profileUser.user_type !== 'hirer'}
            onViewServices={() => {
              navigate(`/profile/${profileUser.id}/services`);
              setShowCollaborationOptions(false);
            }}
            onCustomRequest={() => {
              setCollaborationInitialValues(null);
              setShowCollaborationOptions(false);
              setShowCollaborationModal(true);
            }}
          />
        )}

        {/* Edit Model Profile Modal */}
        {showEditModelSpecsModal && user && (
          <EditModelProfileModal
            isOpen={showEditModelSpecsModal}
            onClose={() => setShowEditModelSpecsModal(false)}
            user={user}
          />
        )}

        {/* Comp Card Modal */}
        {showCompCardModal && user && (
          <CompCardModal
            isOpen={showCompCardModal}
            onClose={() => setShowCompCardModal(false)}
            user={user}
          />
        )}

        {/* Digitals Preview Lightbox Modal */}
        <AnimatePresence>
          {selectedDigitalIndex !== null && user.model_profile?.digitals && (
            <div 
              className="fixed inset-0 z-[9999] bg-black/95 flex items-center justify-center p-4 backdrop-blur-md select-none"
              onClick={() => setSelectedDigitalIndex(null)}
            >
              {/* Close button */}
              <button
                onClick={() => setSelectedDigitalIndex(null)}
                className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-50 shadow-md"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>

              {/* Left navigation arrow */}
              {selectedDigitalIndex > 0 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedDigitalIndex(prev => prev !== null ? prev - 1 : null);
                  }}
                  className="absolute left-4 p-3 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-50 shadow-md"
                >
                  <ChevronLeftIcon className="w-6 h-6" />
                </button>
              )}

              {/* Right navigation arrow */}
              {selectedDigitalIndex < user.model_profile.digitals.length - 1 && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedDigitalIndex(prev => prev !== null ? prev + 1 : null);
                  }}
                  className="absolute right-4 p-3 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-50 shadow-md"
                >
                  <ChevronRightIcon className="w-6 h-6" />
                </button>
              )}

              {/* Active image container */}
              <motion.div
                key={selectedDigitalIndex}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="relative max-w-full max-h-[85vh] flex flex-col items-center gap-4 cursor-default"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={resolveImageUrl(user.model_profile.digitals[selectedDigitalIndex])}
                  alt={`Digital Look ${selectedDigitalIndex + 1}`}
                  className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl border border-white/5"
                />
                <div className="text-center text-white/75 text-xs font-black uppercase tracking-widest mt-2">
                  Digital Look {selectedDigitalIndex + 1} of {user.model_profile.digitals.length}
                </div>
              </motion.div>
            </div>
          )}
        </AnimatePresence>
      </div>

      {/* Full Screen Profile Picture Modal (Circular Frame) */}
      {showFullProfilePic && user.profile_pic && (
        <div 
          className="fixed inset-0 z-[100000] bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setShowFullProfilePic(false)}
        >
          <button 
            onClick={() => setShowFullProfilePic(false)}
            className="absolute top-5 right-5 p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-50 shadow-md"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>

          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="relative flex flex-col items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="w-64 h-64 sm:w-80 sm:h-80 md:w-[420px] md:h-[420px] rounded-full overflow-hidden border-4 border-white/20 dark:border-gray-800/80 shadow-2xl relative">
              <img 
                src={user.profile_pic_signed || user.profile_pic} 
                alt={`${user.first_name} ${user.last_name}`}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="mt-4 text-center text-white text-base md:text-lg font-bold tracking-wide select-none drop-shadow-sm">
              {user.first_name} {user.last_name}
            </div>
          </motion.div>
        </div>
      )}

      {/* // Replace the modals at the bottom */}
        {/* Photo Upload Modals */}
        {showProfilePhotoModal && (
        <PhotoCropperModal
            type="profile"
            currentPhoto={user?.profile_pic}
            onClose={() => setShowProfilePhotoModal(false)}
        />
        )}

        {showCoverPhotoModal && (
        <PhotoCropperModal
            type="cover"
            currentPhoto={user?.cover_photo}
            onClose={() => setShowCoverPhotoModal(false)}
        />
        )}

{/* // Add the modal at the end of your JSX, before the closing div */}
{/* User Relationship Modal */}
{showRelationshipModal && user && (
  <UserRelationshipModal
    isOpen={showRelationshipModal}
    onClose={() => setShowRelationshipModal(false)}
    userId={user.id}
    initialTab={relationshipModalTab}
    userName={`${user.first_name} ${user.last_name}`}
    initialCounts={{
      followers: user.followers_count || 0,
      following: user.following_count || 0,
      collaborators: user.collaborators_count || 0,
    }}
  />
)}
      <ConfirmationModal
        isOpen={deleteConfirmation.isOpen}
        onClose={() => setDeleteConfirmation({ isOpen: false, type: null })}
        onConfirm={handleConfirmDelete}
        title={`Delete ${deleteConfirmation.type === 'profile' ? 'Profile' : 'Cover'} Photo`}
        message={`Are you sure you want to delete your ${deleteConfirmation.type === 'profile' ? 'profile' : 'cover'} photo? This action cannot be undone.`}
        confirmText="Delete"
        type="danger"
      />

        {/* Add Portfolio Modal */}
        {showAddPortfolioModal && (
            <AddPortfolioModal
                onClose={() => setShowAddPortfolioModal(false)}
                onOpenSyncInstagram={IS_INSTAGRAM_SYNC_ENABLED ? handleInstagramSyncClick : undefined}
                onSuccess={(newItem, rewardData?: any) => {
                    setShowAddPortfolioModal(false);
                    setPortfolio(prev => [newItem, ...prev]);
                    // Clear action param
                    navigate(`/profile/${id || user?.id}/portfolio`, { replace: true });
                    // Show reward modal if reward was unlocked
                    if (rewardData) {
                      setRewardModalData(rewardData);
                    }
                }}
            />
        )}

        {/* Create/Edit Folder Modal */}
        {showCreateFolderModal && (
          <CreateFolderModal
            targetUserId={(id || currentUser?.id) || ''}
            existingFolderName={editingFolder?.name}
            existingFolderId={editingFolder?.id}
            onClose={() => {
              setShowCreateFolderModal(false);
              setEditingFolder(null);
            }}
            onSuccess={(folder) => {
              setShowCreateFolderModal(false);
              if (editingFolder) {
                // Update existing folder
                setPortfolioFolders(prev => 
                  prev.map(f => f.id === folder.id ? folder : f)
                );
              } else {
                // Add new folder
                setPortfolioFolders(prev => [folder, ...prev]);
              }
              setEditingFolder(null);
            }}
          />
        )}

        {/* Create Collaboration Modal */}
        {(showCreateCollaboration || instagramPreFill) && (
          <CreateCollaborationModal
            instagramPreFill={instagramPreFill || undefined}
            onOpenSyncInstagram={IS_INSTAGRAM_SYNC_ENABLED ? () => handleInstagramSyncClick('project') : undefined}
            onClose={() => {
              setShowCreateCollaboration(false);
              setInstagramPreFill(null);
            }}
            onSuccess={(rewardData?: any) => {
              setShowCreateCollaboration(false);
              setInstagramPreFill(null);
              // Refresh collaborations
              const targetUserId = id || user?.id;
              if (targetUserId) {
                dispatch(fetchUserCollaborations(targetUserId));
              }
              // Clear action param and navigate to collaborations tab
              navigate(`/profile/${id || user?.id}/projects`, { replace: true });
              // Show reward modal if reward was unlocked
              if (rewardData) {
                setRewardModalData(rewardData);
              }
            }}
          />
        )}

        {/* Instagram Import Modal */}
        {isIgImportModalOpen && IS_INSTAGRAM_SYNC_ENABLED && (
          <InstagramImportModal
            isOpen={isIgImportModalOpen}
            initialMode={igImportMode}
            onClose={() => setIsIgImportModalOpen(false)}
            onSuccessPhotos={handleInstagramPhotosSuccess}
            onSuccessProject={(preFill) => setInstagramPreFill(preFill)}
          />
        )}

      {/* Login Prompt Modal for Guests */}
      <LoginPromptModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        message={loginModalMessage}
      />
      </div>
      {/* [Subscription removed] UpgradePopup removed */}
      {/* Reward Unlocked Modal */}
      {rewardModalData && (
        <RewardUnlockedModal
          isOpen={!!rewardModalData}
          onClose={() => {
            setRewardModalData(null);
            // Refresh user to get updated subscription info
            if (user?.id) {
              dispatch(updateUser({
                reward_claimed: true,
                subscription_tier: rewardModalData.tier,
              }));
            }
          }}
          rewardData={rewardModalData}
        />
      )}
    </div>
  );
};

export default ProfilePage;